// extracted by mini-css-extract-plugin
export default {"container":"progress-indicator_container"};